import React from 'react';
import { Link, Outlet } from 'react-router-dom';
export function Layout() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white selection:bg-white/20 flex flex-col" data-id="element-381">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/80 backdrop-blur-md border-b border-neutral-900" data-id="element-382">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-383">
          <Link to="/" className="flex items-center gap-2 font-semibold text-xl tracking-tight" data-id="element-384">
            <img src="https://cdn.magicpatterns.com/uploads/s8vqqcPfFZev6SgcxxebLW/brainwhite.svg" alt="GigaBrain" className="w-7 h-7" data-id="element-385" />
            GigaBrain
          </Link>
          <div className="flex items-center gap-6 text-sm font-medium" data-id="element-386">
            <a href="#" className="text-neutral-400 hover:text-white transition-colors" data-id="element-387">
              Product
            </a>
            <a href="#" className="text-neutral-400 hover:text-white transition-colors" data-id="element-388">
              Use Cases
            </a>
            <a href="#" className="text-neutral-400 hover:text-white transition-colors" data-id="element-389">
              Docs
            </a>
            <button className="px-4 py-2 bg-white text-black rounded-full hover:bg-neutral-200 transition-colors" data-id="element-390">
              Sign In
            </button>
          </div>
        </div>
      </nav>

      <main className="flex-grow" data-id="element-391">
        <Outlet data-id="element-392" />
      </main>

      {/* Footer */}
      <footer className="border-t border-neutral-800 bg-[#0a0a0a]" data-id="element-393">
        <div className="max-w-6xl mx-auto px-6 py-16" data-id="element-394">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-10 mb-16" data-id="element-395">
            {/* Brand */}
            <div className="col-span-2 md:col-span-1" data-id="element-396">
              <div className="flex items-center gap-2 font-semibold text-lg tracking-tight mb-4" data-id="element-397">
                <img src="https://cdn.magicpatterns.com/uploads/s8vqqcPfFZev6SgcxxebLW/brainwhite.svg" alt="GigaBrain" className="w-6 h-6" data-id="element-398" />
                GigaBrain
              </div>
              <p className="text-sm text-neutral-500 leading-relaxed" data-id="element-399">
                AI that works with your whole team, across every tool.
              </p>
            </div>

            {/* Use Cases */}
            <div data-id="element-400">
              <h4 className="text-sm font-semibold text-white mb-4" data-id="element-401">
                Use Cases
              </h4>
              <ul className="space-y-2.5" data-id="element-402">
                <li data-id="element-403">
                  <a href="#" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-404">
                    For Agencies
                  </a>
                </li>
                <li data-id="element-405">
                  <a href="#" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-406">
                    For Startups
                  </a>
                </li>
                <li data-id="element-407">
                  <a href="#" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-408">
                    For Sales Teams
                  </a>
                </li>
                <li data-id="element-409">
                  <a href="#" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-410">
                    For Marketing
                  </a>
                </li>
                <li data-id="element-411">
                  <a href="#" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-412">
                    For Engineering
                  </a>
                </li>
                <li data-id="element-413">
                  <a href="#" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-414">
                    For Customer Success
                  </a>
                </li>
              </ul>
            </div>

            {/* Product */}
            <div data-id="element-415">
              <h4 className="text-sm font-semibold text-white mb-4" data-id="element-416">Product</h4>
              <ul className="space-y-2.5" data-id="element-417">
                <li data-id="element-418">
                  <a href="#" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-419">
                    Features
                  </a>
                </li>
                <li data-id="element-420">
                  <a href="#" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-421">
                    Integrations
                  </a>
                </li>
                <li data-id="element-422">
                  <a href="#" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-423">
                    Pricing
                  </a>
                </li>
                <li data-id="element-424">
                  <a href="#" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-425">
                    Changelog
                  </a>
                </li>
                <li data-id="element-426">
                  <a href="#" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-427">
                    Security
                  </a>
                </li>
              </ul>
            </div>

            {/* Resources */}
            <div data-id="element-428">
              <h4 className="text-sm font-semibold text-white mb-4" data-id="element-429">
                Resources
              </h4>
              <ul className="space-y-2.5" data-id="element-430">
                <li data-id="element-431">
                  <a href="#" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-432">
                    Documentation
                  </a>
                </li>
                <li data-id="element-433">
                  <a href="#" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-434">
                    API Reference
                  </a>
                </li>
                <li data-id="element-435">
                  <a href="#" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-436">
                    Blog
                  </a>
                </li>
                <li data-id="element-437">
                  <a href="#" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-438">
                    Community
                  </a>
                </li>
              </ul>
            </div>

            {/* Company */}
            <div data-id="element-439">
              <h4 className="text-sm font-semibold text-white mb-4" data-id="element-440">Company</h4>
              <ul className="space-y-2.5" data-id="element-441">
                <li data-id="element-442">
                  <Link to="/about" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-443">
                    About Us
                  </Link>
                </li>
                <li data-id="element-444">
                  <Link to="/careers" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-445">
                    Careers
                  </Link>
                </li>
                <li data-id="element-446">
                  <Link to="/contact" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-447">
                    Contact
                  </Link>
                </li>
                <li data-id="element-448">
                  <Link to="/privacy" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-449">
                    Privacy Policy
                  </Link>
                </li>
                <li data-id="element-450">
                  <Link to="/terms" className="text-sm text-neutral-500 hover:text-white transition-colors" data-id="element-451">
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="pt-8 border-t border-neutral-800 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-452">
            <p className="text-sm text-neutral-600" data-id="element-453">
              © 2026 GigaBrain Inc. All rights reserved.
            </p>
            <div className="flex items-center gap-5" data-id="element-454">
              <a href="#" className="text-neutral-600 hover:text-white transition-colors text-sm" data-id="element-455">
                Twitter
              </a>
              <a href="#" className="text-neutral-600 hover:text-white transition-colors text-sm" data-id="element-456">
                GitHub
              </a>
              <a href="#" className="text-neutral-600 hover:text-white transition-colors text-sm" data-id="element-457">
                LinkedIn
              </a>
              <a href="#" className="text-neutral-600 hover:text-white transition-colors text-sm" data-id="element-458">
                Discord
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}